<script>
import { RoleTypes } from '@resources/js/constants/feed.constant';

const ROLE_CONFIG = {
  [RoleTypes.ADMIN]: { label: 'Admin', modifier: 'admin' },
  [RoleTypes.CAMPAIGN]: { label: 'Campaign', modifier: 'campaign' },
  [RoleTypes.CAMPAIGN_OWNER]: { label: 'Campaign Owner', modifier: 'campaignOwner' },
  [RoleTypes.OFFICIAL]: { label: 'Official', modifier: 'official' },
  [RoleTypes.MANAGED_ACCOUNT]: { label: 'Managed Account', modifier: 'managedAccount' },
};

export default {
  name: 'CpRoleBadge',
  directives: {
    margin: require('@resources/js/directives/margins').margin,
  },
  props: {
    role: { type: String, default: '' },
    iconOnly: { type: Boolean, default: false },
    iconSize: { type: Number, default: 14 },
  },
  computed: {
    config() {
      return ROLE_CONFIG[this.role] || null;
    },
    badgeModifier() {
      return this.config ? `roleBadge--${this.config.modifier}` : '';
    },
    badgeClass() {
      const modifiers = [this.badgeModifier];
      if (!this.iconOnly) modifiers.push('roleBadge--withLabel');
      return modifiers.filter(Boolean).join(' ');
    },
  },
};
</script>

<template>
  <span v-if="config" class="roleBadge" :class="badgeClass">
    <i class="fas fa-star" :style="{ fontSize: iconSize + 'px' }" aria-hidden="true"></i>
    <span v-if="!iconOnly" class="roleBadge__label caption" v-margin="0">{{ config.label }}</span>
  </span>
</template>

<style scoped>
.roleBadge {
  display: inline-flex;
  align-items: center;
  width: fit-content;
  gap: 4px;
  padding: 4px;
  border-radius: 30px;
}
.roleBadge--withLabel {
  padding-left: 8px;
  padding-right: 8px;
}
.roleBadge--admin {
  background-color: var(--primary-1);
  color: var(--primary);
}
.roleBadge--campaign,
.roleBadge--campaignOwner {
  background-color: var(--secondary-1);
  color: var(--secondary);
}
.roleBadge--official {
  background-color: var(--success-1);
  color: var(--success);
}
.roleBadge--managedAccount {
  background-color: var(--warning-1);
  color: var(--warning-3);
}
</style>
